import React from 'react';
import { concatStyles } from 'utils';
var LIST_ITEM_STYLES = 'flex flex-row list-none py-1 px-0 flex-shrink-0 flex-grow';
export var ListItem = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return (React.createElement("li", { className: concatStyles([LIST_ITEM_STYLES, className]), style: style }, children));
};
ListItem.displayName = 'Content.ListItem';
